import { type FC } from "react";
import NavbarSidebarLayout from "../layouts/navbar-sidebar";
import TelephonyDevices from "../components/devices/TelephonyDevices";

const TelephonyDevicesPage: FC = function () {
  return (
    <NavbarSidebarLayout>
      <div className="px-4 pt-6 pb-8">
        <TelephonyDevices />
      </div>
    </NavbarSidebarLayout>
  );
};

export default TelephonyDevicesPage;

